export default __webpack_public_path__ + "static/banner-travelling-around-australia-on-a-budget-0264c84e22618fe412b4e571a951e8dc.jpg";